module.exports = __webpack_public_path__ + "img/img-103.db72220c.png";